import React from "react";
import NeedHelpBox from "../../Commons/NeedHelpBox";
import { portalLogoUrl } from "../../../helper/utils";

export default function FooterSignInPopup({ pId }) {

    return (
        <div style={{width: "100%", marginTop: "3rem"}}>
            <div className='row footer-content'>
                <div className="col-12">
                    <NeedHelpBox pId={pId} signInFooter />
                </div>
                {/* <div className="col-3 text-right">
                    <img src={portalLogoUrl()} style={{ width: "75px", height: "39px" }}/>
                </div> */}
            </div>
        </div>
    );
}